"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrientationStatus = void 0;
exports.instanceOfOrientationStatus = instanceOfOrientationStatus;
exports.OrientationStatusFromJSON = OrientationStatusFromJSON;
exports.OrientationStatusFromJSONTyped = OrientationStatusFromJSONTyped;
exports.OrientationStatusToJSON = OrientationStatusToJSON;
exports.OrientationStatusToJSONTyped = OrientationStatusToJSONTyped;
/**
 *
 * @export
 */
exports.OrientationStatus = {
    Active: 'ACTIVE',
    Canceled: 'CANCELED'
};
function instanceOfOrientationStatus(value) {
    for (const key in exports.OrientationStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.OrientationStatus, key)) {
            if (exports.OrientationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function OrientationStatusFromJSON(json) {
    return OrientationStatusFromJSONTyped(json, false);
}
function OrientationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrientationStatusToJSON(value) {
    return value;
}
function OrientationStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=OrientationStatus.js.map